import { Injectable } from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {catchError, map, Observable, of, tap} from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): Observable<boolean> {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('code');

    if (token) {
      return this.authService.requestToken(token!).pipe(
        map(() => {
          window.location.href = window.location.pathname;
          return true;
        }),
        catchError(() => of(false))
      );
    }
    if (this.authService.getToken()) {
      return of(true);
    }

    return of(false).pipe(
      tap(() => this.router.navigate(['/no-access']))
    );
  }
}
